module.exports = __webpack_public_path__ + "static/media/Lato-Regular.5d143919.ttf";